import { colors, Stack, Typography } from '@ui-components/neo.tax';

import { StyledGauge, StyledStack } from './qre-allocation.styled';

type EditQreAllocationProps = {
  projectAllocations: {
    projectId: string;
    allocationPercent: number;
  }[];
  totalRdProjectAllocation: number;
  onEditClick: () => void;
};

export const EditQreAllocation = ({
  onEditClick,
  projectAllocations,
  totalRdProjectAllocation,
}: EditQreAllocationProps): JSX.Element => (
  <Stack direction="column" gap={1}>
    <Typography color={colors.gray[400]} fontWeight="medium" fontSize="sm">
      Full Project Allocation{' '}
      <Typography color="inherit" fontWeight="bold" fontSize="inherit">
        ({Math.round(totalRdProjectAllocation)}% R&D)
      </Typography>
    </Typography>
    <StyledStack direction="row" borderRadius="lg" fullWidth backgroundColor={colors.black}>
      {projectAllocations.map((projectAllocation) => (
        <StyledGauge key={projectAllocation.projectId} fullHeight percent={projectAllocation.allocationPercent} />
      ))}
    </StyledStack>
    <Typography
      as="button"
      onClick={onEditClick}
      textAlign="left"
      color={colors.primary[600]}
      fontSize="sm"
      type="button"
    >
      Click to Edit Project Allocation
    </Typography>
  </Stack>
);
